import React, { PropsWithChildren } from 'react';
import { WarningStyle } from './style';

const Warning = (props: PropsWithChildren<object>): JSX.Element => {
  const { children } = props;

  return <WarningStyle>{children}</WarningStyle>;
};

export default Warning;
